function PredictiveSearch() {
  const section = document.querySelector(".p-search-section");
  const input = document.querySelector(".search-input");
  const results = document.querySelector(".predictive-search");
  const clearBtn = document.querySelector(".search-clear");
  const toggles = document.querySelectorAll(".js-search-toggle");
  const headerMenu = document.querySelector(".header-menu");

  if (!section || !input || !results || !clearBtn) return;

  const loadingSkeleton = Array(4).fill(
    '<div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>'
  ).join("");

  function hideResults({ clearInput = false } = {}) {
    results.style.display = "none";
    results.classList.remove("open");
    clearBtn.style.display = "none";
    if (clearInput) input.value = "";
  }

    function closePanel() {
      hideResults();
      section.style.display = "none";
    }

    function debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    }

    function fetchSearchResults(query) {
      if (!query.trim()) {
        hideResults();
        return;
      }

      results.innerHTML = loadingSkeleton;
      results.style.display = "block";
      results.classList.add("open");

      const params = new URLSearchParams({
        q: query,
        section_id: "predictive-search",
        "resources[type]": "product,article,page",
        "resources[limit]": 6,
        "resources[limit_scope]": "each",
        "resources[options][unavailable_products]": "hide",
        "resources[options][fields]": "title,product_type,variants.title,vendor"
      });
      const root = window.Shopify?.routes?.root || "/";

      fetch(`${root}search/suggest?${params}`)
        .then(r => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(html => {
          const el = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector("#shopify-section-predictive-search");
          if (!el) throw new Error("predictive-search section not found in response");

          results.innerHTML = el.innerHTML;
          results.style.display = "block";
          clearBtn.style.display = "block";
        })
        .catch(err => {
          console.error("Predictive search failed:", err);
          hideResults(); // keeps what the user typed
        });
    }

    input.addEventListener("input", debounce(() => fetchSearchResults(input.value), 300));

    clearBtn.addEventListener("click", () => {
      hideResults({ clearInput: true });
      input.focus();
    });

    toggles.forEach(btn => {
      btn.addEventListener("click", e => {
        e.stopPropagation();
        const isOpen = section.style.display === "block";
        section.style.display = isOpen ? "none" : "block";
        if (!isOpen) {
          headerMenu?.classList.remove("show-menu");
          input.focus();
        }
      });
    });

  document.addEventListener("click", e => {
    if (!section.contains(e.target) && !e.target.closest(".js-search-toggle")) {
      closePanel();
    }
  });
}

document.addEventListener("DOMContentLoaded", PredictiveSearch);